export const ugovor_o_sponzorstvu = {
    templateId: 49.4,
    category: 5,
    templateTitle: "Ugovor o sponzorstvu",
    templateDescription: `<p>Ugovorom o sponzorstvu, sponzor se obvezuje organizatoru dati potporu u novcu, stvarima ili uslugama, u određenoj priredbi, projektu ili općenito u radu, a organizator se obvezuje sponzoru dati protučinidbu u vidu reklame i sl..</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Sponzorstvo je davanje u novcu, stvarima ili uslugama pravnoj ili fizičkoj osobi uz određenu protuuslugu (promidžbenu, reklamnu i sl.).</p>
    <p>Razlika u odnosu na donaciju je u tome što kod donacije primatelj ne daje nikakvu protučinidbu. Osim toga, sponzor, za razliku od donatora evidentira troškove sponzorstva kao trošak promidžbe i u potpunosti su porezno priznati bez potrebe ispunjenja uvjeta koji su propisani za donaciju.</p>
    <p>Sponzor može sponzorirati:</p>
    <li> održavanje određenih javnih priredbi (umjetničkih, kulturnih, zabavnih, športskih), ili </li>
    <li> dati potporu institucijama, udrugama, društvima (kazališta, športski klubovi), ili </li>
    <li> potporu određenim akcijama i projektima (festivali, turniri, knjige), ili </li>
    <li> potporu poznatim osobama (športašima, pjevačima)</li>
    <li>i sl..</li>

    <br>

    <p>Određena protučinidba primatelja sponzorstva (organizatora) može biti davanje prava sponzoru na promidžbu (reklamu) svojeg branda, tvrtke ili proizvoda na različite načine - navođenje u promotivnim materijalima, u pisanim materijalima, knjigama, oznakama ili panoima uključujući i dresove odnosno odjeću primatelja sponzorstva i sl..</p>
    <p>Ako se sponzorstvo obavlja u stvarima ili uslugama, sponzor je dužan ispostaviti račun.</p>
    <p>Također, primatelj sponzorstva (organizator) dužan je ispostaviti sponzoru  račun za izvršene usluge promidžbe.</p>
   
    
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o obveznim odnosima - u općenitom smislu primjene na sve ugovore.</p>
  `,

    sides: [
        {
            signature: 'Sponzor:',
            inputs: [{
                type: 'input',
                required: true,
                placeholder: 'Poslovni subjekt',
            },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Ulica i kućni broj',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Mjesto',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'OIB',
                },
                {
                    type: "input",
                    placeholder: "Zastupa",
                    inSignature: true,
                  },
                  {
                    type: "input",
                    placeholder: "Funkcija",
                    inSignature: true,
                }],
            suffix: ' (u daljnjem tekstu: Sponzor)',
            delimiter: `i`
        },
        {
            signature: 'Organizator:',
            inputs: [{
                type: 'input',
                required: true,
                placeholder: 'Naziv Organizatora',
            },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Ulica i kućni broj',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Mjesto',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'OIB',
                },
                {
                    type: "input",
                    placeholder: "Zastupa",
                    inSignature: true,
                  },
                  {
                    type: "input",
                    placeholder: "Funkcija",
                    inSignature: true,
                }],
            
            suffix: ' (u daljnjem tekstu: Organizator),'
        }
    ],

    headline: 'zaključuju sljedeći',
    title: 'UGOVOR SPONZORSTVU',
    noArticleNumbers: false,

    articles: [

        {
            title: 'PREDMET UGOVORA',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ovim Ugovorom, Sponzor se obvezuje u vidu sponzorstva dati potporu Organizatoru, a Organizator prima navedenu potporu te se obvezuje zauzvrat osigurati promidžbu Sponzoru, oboje na način određen odredbama ovog Ugovora.',
                    value: '',
                }],
        },
        {
            title: 'PREDMET DONACIJE',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Predmet sponzorstva je novčani iznos od'},
                                {type: 'input', value: '', required: true,},
                                {type: 'text', content: ', koji će biti realiziran uplatom na račun Organizatora'},
                                {
                                    type: 'text',
                                    content: 'otvoren kod'
                                },
                                {type: 'input', value: '', required: true,},
                                {type: 'text', content: 'd.d..'},
                                {help: 'Upišite naziv banke u kojoj Primatelj donacije ima otvoren račun.'}
                            ]},
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Predmet sponzorstva su stvari, i to:'
                                },
                                {type: 'textarea', value: '', required: true,},
                              ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Predmet sponzorstva su usluge, i to:'
                                },
                                {type: 'textarea', value: '', required: true,},]
                        }],
                    value: '',
                }
            ]
        },
        {
            title: 'REALIZACIJA SPONZORSTVA',
            mandatory: true,
            editable: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    parts: [
                        {type: 'text', content: 'Sponzor se obvezuje sponzorirati Organizatora'},
                        {type: 'textarea', value: '', required: true, placeholder: 'primjer: "uplatom novčanih sredstava roku od..."',  help: "Ovdje upisujete rok ispunjenja predmeta sponzorstva"},
                      ],
                }],
            value: '',
        },
        {
            title: 'OBVEZE ORGANIZATORA',
            mandatory: true,
            editable: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    parts: [
                        {type: 'text', content: 'Organizator će omogućiti Sponzoru obavljanje sljedećih promidžbenih aktivnosti:'},
                        {type: 'textarea', value: '', required: true,},
                      ],
                }],
            value: '',
        },
        {
            title: 'MEĐUSOBNE OBVEZE',
            mandatory: false,
            editable: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    parts: [
                        {type: 'text', content: 'Ugovorne strane imaju sljedeće međusobne obveze:'},
                        {type: 'textarea', value: '', required: true, help: "npr. dostava originalnog logotipa, promidžbenog teksta, materijala, podataka i sl.",},
                      ],
                }],
            value: '',
        },
        {
            title: 'EKSKLUZIVNOST',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Ovim ugovorom Organizator jamči Sponzoru ekskluzivnost, što znači da neće sklapati istovrsne ugovore s drugim fizičkim ili pravnim osobama koje se bave djelatnostima Sponzora.'
                                }
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Ovim ugovorom Organizator ne  jamči Sponzoru ekskluzivnost, što znači da neće sklapati istovrsne ugovore s drugim fizičkim ili pravnim osobama koje se bave djelatnostima Sponzora.                                    '
                                }
                            ]
                        },
                     
                    ],
                    value: '',
                }
            ]
        },
        {
            title: 'NADLEŽNOST',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom za Sponzora.'
                                }
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom za Organizatora.'
                                }
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom u'
                                },
                                {type: 'input', value: '',help: "Upišite mjesno nadležni sud. Npr. ...sudom u Zagrebu; ...sudom u Splitu i sl..", required: true},
        ]
                        }
                    ],
                    value: '',
                }
            ]
        },
        {
            title: 'PRIMJENA UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ugovor se primjenjuje od trenutka potpisa ugovornih strana.',
                    value: '',
                }
            ],
            addRows: 5,
        },
        {
            title: 'PRIMJERCI UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ovaj Ugovor sastavljen je u 2 (dva) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
                    value: '',
                }
            ],
            addRows: 5,
          },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine."
                  }
                ]
              },
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
    ],
};




// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/49.4_ugovor_o_sponzorstvu.ts